import { redactAccessLinkFragment } from '@/lib/access-link-fragment'

const REDACTED = '[REDACTED]'
const SENSITIVE_KEY = /(secret|password|token|apikey)|^code$/i
const JSON_DOCUMENT_START = /^\s*[{[]/

const isPlainData = (value: object): boolean =>
  Object.prototype.toString.call(value) === '[object Object]'

const redactValue = (value: unknown): unknown => {
  if (typeof value === 'string') {
    return redactAccessLinkFragment(value)
  }

  if (Array.isArray(value)) {
    return value.map((item) => redactValue(item))
  }

  if (typeof value === 'object' && value !== null && isPlainData(value)) {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [
        key,
        SENSITIVE_KEY.test(key) ? REDACTED : redactValue(entry),
      ]),
    )
  }

  return value
}

export const redactJsonString = (value: string): string => {
  if (!JSON_DOCUMENT_START.test(value)) {
    return redactAccessLinkFragment(value)
  }

  try {
    return JSON.stringify(redactValue(JSON.parse(value)))
  } catch {
    return value
  }
}

export const redactSensitive = (value: unknown): unknown =>
  typeof value === 'string' ? redactJsonString(value) : redactValue(value)
